import { scroller } from 'react-scroll'
import { t } from '../../../utilities/translator'
import { useDispatch, useSelector } from 'react-redux'
// import { updateDatesFilter } from '../../mainFilter/mainFilterSlice'
import { selectSearch } from '../../mainFilter/searchSlice'
import { selectDateFilter } from '../../mainFilter/selectors'
import { updateMainFilterModal } from '../../mainFilter/mainFilterModalsSlice'
import abTesting from '../../../services/abTesting'
import { getDisplayPrice } from '../../../utilities/priceHelper';
import { setPreselectedDateType, toggleCustomize, toggleCustomizePanel } from '../../customize-button/customizeButtonSlice'
import { CUSTOMIZE, DATE_TYPES } from '../../../constants/constants'
import { isMobile } from '../../../utilities/helpers'
import DotsPulse from '../../../components/animations/DotsPulse'

const NonCachedFooter = ({
  state,
  selected,
  onPickDatesClick,
  dealItem,
}) => {
  const dispatch = useDispatch()
  const search = useSelector(selectSearch)
  const datesFilter = useSelector(selectDateFilter)
  const buttonLabel = selected
    ? t('hotelItem.check_prices_selected')
    : t('hotelItem.check_prices');

  const handlePickDatesClick = () => {
    if (onPickDatesClick) {
      return onPickDatesClick();
    }

    const priceGraphElement = document.querySelector('.price-graph');

    if (priceGraphElement) {
      scroller.scrollTo('price-graph', {
        delay: 200,
        offset: -170,
        smooth: true,
        duration: 2000,
      });

      priceGraphElement.classList.add('price-graph--check');
    } else {
        if (abTesting.customizeButton && isMobile()) {
          dispatch(toggleCustomize(true));
          setTimeout(() => dispatch(toggleCustomizePanel(CUSTOMIZE.WHEN)), 0);
          dispatch(setPreselectedDateType(DATE_TYPES.SPECIFIC));
        } else {
          /* dispatch(updateDatesFilter({
            ...search,
            ...datesFilter,
            type: 'specific',
          })) */
          dispatch(updateMainFilterModal({ when: true }));
          scroller.scrollTo('scrollToResults', {
            delay: 100,
            offset: -100,
            smooth: true,
            duration: 1000,
          });
        }
    }
  }

  let element = null;

  if ((state === 'available' || state === 'proposal') && dealItem) {
    const getCapacity = () => {
      const {
        capacity: {
          adult,
          child
        },
        capacity_from_filter,
      } = dealItem.offer;
      let kids = child;
      const babies =
        capacity_from_filter.childAges.filter((kid) => kid < 2).length || 0;
      kids = kids - babies;

      return { adult, kids, babies };
    };
    const getOfferPrice = () => {
      const {
        price,
      } = dealItem.offer;
      const { adult, kids } = getCapacity();

      return getDisplayPrice(Math.ceil(price / (adult + kids)));
    };
    element = (
      <div className="deal-footer flex justify-end gap-2 p-4">
        <div className="flex flex-col gap-1 items-end js-offer-price" data-total-price={dealItem?.offer?.price}>
          <span className="text-xl font-bold leading-none">{getOfferPrice()}</span>
          <span className="text-[10px] !font-medium leading-none">{t('dealItem.per_person')}</span>
        </div>
      </div>
    )
  }

  if (state === 'default') {
    element = (
      <div className="deal-footer min-h-15 bg-shark-50 px-3 flex justify-between gap-4 items-center rounded-b-xl" style={{ height: '66px' }}>
        <span className="caption-strong leading-14px">{t('hotelItem.pick_departure')}</span>
        <button className="move-btn-primary caption-strong !font-semibold p-2" onClick={handlePickDatesClick}>{buttonLabel}</button>
      </div>
    )
  }

  if (state === 'sold') {
    element = (
      <div className="deal-footer sold-out min-h-15 bg-shark-50 px-2 flex justify-between gap-2 items-center rounded-b-xl" style={{ height: '66px' }}>
        <span className="caption-strong leading-14px">{t('dealItem.soldOut')}</span>
        <button className="move-btn-primary caption-strong !font-semibold p-2" onClick={handlePickDatesClick}>{t('dealItem.checkDates')}</button>
      </div>
    )
  }

  if (state === 'pending') {
    element = (
      <div className="deal-footer min-h-15 bg-shark-50 px-3 py-4 flex justify-between gap-4 items-center rounded-b-xl" style={{ height: '66px' }}>
        <span className="caption-strong leading-14px">{t("dealItem.checkingAvailability")}</span>
        <button className="move-btn-primary caption-strong !font-semibold p-2">
          <DotsPulse
            className="px-7 py-1"
            count={4}
            color="black"
          />
        </button>
      </div>
    )
  }

  // if (state === 'proposal') {
  //   element = (
  //     <div className="deal-footer flex justify-end gap-2 p-4">
  //     <div className="flex flex-col gap-1 items-end js-offer-price" data-total-price={dealItem?.offer?.price}>
  //       <span className="text-xl font-bold leading-none">{}</span>
  //       <span className="text-[10px] !font-medium leading-none">{t('dealItem.per_person')}</span>
  //     </div>
  //   </div>
  //   )
  // }

  return element;
}

export default NonCachedFooter;
